.login-page {
    background-image: url("/images/fon.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-blend-mode: darken;
    background-color: #0000008a;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: white;
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
}

.login-page h1,
.login-page p,
.login-page button {
    z-index: 2;
}

.login-page h1 {
    text-align: center;
    margin-top: 10rem;
    margin-bottom: 2rem;
    font-size: 4rem;
    max-width: 36rem;
}

.login-page p {
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 6rem;
}

.login-page button {
    background-color: #cc4400;
    color: white;
    border: none;
    padding: 20px 35px;
    text-align: center;
    text-decoration: none;
    font-size: 1.2rem;
    border-radius: 2rem;
    margin-bottom: 5rem;
    cursor: pointer;
}

@media (max-width: 768px) {
    .login-page {
        height: auto;
        padding: 2rem;
    }

    .login-page h1 {
        font-size: 2.5rem;
        margin-top: 3rem;
    }

    .login-page p {
        font-size: 1.2rem;
        margin-bottom: 4rem;
    }

    .login-page button {
        padding: 15px 30px;
        font-size: 1rem;
        margin-bottom: 3rem;
    }
}

@media (max-width: 480px) {
    .login-page h1 {
        font-size: 2rem;
        margin-top: 2rem;
    }

    .login-page p {
        font-size: 1rem;
        margin-bottom: 3rem;
    }

    .login-page button {
        padding: 12px 25px;
        font-size: 0.9rem;
        margin-bottom: 2rem;
    }
}
